import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import cssClasses from "./ChannelPartner.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import PlusIcon from "../Icons/PlusIcon";
import { DataGrid } from "@mui/x-data-grid";
import Dot from "../Icons/Dot";
import checked from "../../Assets/Images/Common/checked.svg";
import debounce from "lodash.debounce";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DateComponent from "../../Subcomponents/DateComponent";
import { supabase } from "../../supabaseClient";
//SERVICE

import useAlertModal from "../../Subcomponents/useAlertModal";
import {
  getAllCp,
  updateStatus,
  insertCpLogs,
  getAllCpFromCpTable,
  getAllFOSFromTable,
  CheckCpDisplayIdExists,
  CheckCpIdExists,
  CheckFosIdExists,
  deleteAuthByEmail,
  CreateNewBroker,
  getKYCDocuments,
  getFOSKYCDocuments,
  getDeletedCpData,
  getDeletedFosData,
  updateFosCP,
  suspendCp,
  suspendFos,
  insertFosLogs,
  unlockCpProfileForEdit,
} from "../../Services/ChannelPartner";

import { authSignUp, getUserByUserId } from "../../Services/Users";
import { uploadCpToContactGroup } from "../../Services/CpSourcingApis";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
//Modal
import ViewCPDetails from "../../Modals/ViewCPDetails/ViewCPDetails";
import RejectReason from "../../Modals/RejectReason/RejectReason";
import SuspendCpSummary from "../../Modals/SuspendCpSummary/SuspendCpSummary";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import AssignBenefitPlanCP from "../../Modals/AssignBenefitPlanCP/AssignBenefitPlanCP";

import { Network } from "@capacitor/network";
import ViewFOSDetails from "../../Modals/ViewFOSDetails/ViewFOSDetails";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { sendResetPasswordMailCP } from "../../Services/LoginService";
import { Tab, Tabs } from "@mui/material";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import ViewFOSIDDetails from "../../Modals/ViewFOSIDDetails/ViewFOSIDDetails";
import useMediaQuery from "@mui/material/useMediaQuery";
import PartnersMobile from "./Mobile/PartnersMobile";
import CpFosListSheet from "./Mobile/CpFosListSheet";
import { fosDisplayLabel } from "./Mobile/partnersMobileUtils";
import { getLedgerSyncStatus } from "./ledgerSyncUtils";

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
};

// created_at holds a full timestamp, so a day is matched as the whole day
// rather than an instant — otherwise picking "4 Aug" would miss everything
// created after 00:00 that morning.
const startOfDayMs = (value) => {
  const d = new Date(Number(value));
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

const endOfDayMs = (value) => {
  const d = new Date(Number(value));
  d.setHours(23, 59, 59, 999);
  return d.getTime();
};

// DateComponent defaults minDate to today, which would make every past date
// unpickable — and CPs go back years.
const DATE_FILTER_MIN = new Date(2015, 0, 1);

const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// A 10-digit number gets +91; anything else is assumed to already carry a country
// code. Returns "NA" when there is no number, rather than the "+undefined" the
// previous inline expression produced for suspended CPs.
const formatCpContactNumber = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "NA";
  const digits = raw.toString();
  return digits.length === 10 ? "+91" + digits : "+" + digits;
};

export default function ChannelPartner() {
  const dispatch = useDispatch();
  const { showSuccess, showError, showInfo, AlertModal } = useAlertModal();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageMaintainFos, setPageMaintainFos] = useState(0);
  const [pageNumberFos, setPageNumberFos] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  const [viewCPDetailsModal, setViewCPDetailsModal] = useState(false);
  const [viewFOSDetailsModal, setViewFOSDetailsModal] = useState(false);
  const [viewData, setViewData] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [cp, setCP] = useState([]);
  const [search, setSearch] = useState("");
  const [searchFos, setSearchFos] = useState("");
  const [showDropDown, setShowDropDown] = useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: "None", select: true },
    { label: "Status", select: false },
    { label: "Type", select: false },
    { label: "Date", select: false },
  ]);
  // ── Created-on date filter ──
  const [showDateDropDown, setShowDateDropDown] = useState(false);
  // Pending picker values (epoch ms, "" when unset) — mirrors Leads' selectDates.
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [dateHelperText, setDateHelperText] = useState({ startDate: "", endDate: "" });
  // Applied range, held in a ref so every existing getCp() caller (sort, search,
  // pagination, row actions) keeps the filter without threading two more
  // positional args through 13 call sites.
  const appliedDatesRef = useRef({ start: null, end: null });
  const [selectFilter, setSelectedFilter] = useState("");
  const [showAllStatusDropDown, setShowAllStatusDropDown] = useState(false);
  const [allStatusDropDown, setAllStatusDropDown] = useState([
    {
      label: "pending",
      value: false,
    },
    {
      label: "approved",
      value: false,
    },
    {
      label: "rejected",
      value: false,
    },
    {
      label: "resubmitted",
      value: false,
    },
  ]);
  const [showTypeDropDown, setShowTypeDropDown] = useState(false);
  const [allTypeDropDown, setAllTypeDropDown] = useState([
    {
      label: "Entity",
      value: false,
    },
    {
      label: "Individual",
      value: false,
    },
  ]);
  //selected values from array
  const [selectedFilterValues, setSelectedFilterValues] = useState("");
  const [selectedStatusArray, setSelectedStatusArray] = useState([]);
  const [selectedTypeArray, setSelectedTypeArray] = useState([]);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [displayMessage, setDisplayMessage] = useState("");
  const [menuArray, setMenuArray] = useState([
    { label: "Approve", value: "approved", menuAccessName: 'Accept' },
    { label: "Reject", value: "rejected", meta: { showInApproval: false }, menuAccessName: 'Reject/Suspend' },
    {
      label: "Suspend",
      value: "rejected",
      menuAccessName: 'Reject/Suspend',
      meta: { showInApproval: true, duplicate: true },
    },
    { label: "View Details", value: "View Details", menuAccessName: 'View Details' },
    { label: "Assign Benefit Plan", value: "Assign Benefit Plan", menuAccessName: 'Assign Benefit Plan' },
    { label: "View FOS Details", value: "View FOS Details", menuAccessName: 'View FOS Details' },
    // { label: 'View FOS Details', value: 'View FOS Details', meta: { hideForIndividual: true } }
    { label: "Reset Password", value: "Reset Password", menuAccessName: 'Reset Password' },
    // Admin-triggered unlock for an approved CP to edit their own profile again
    // without being rejected first (see CP_PROFILE_UPDATE_DEV_SPEC.md).
    // onlyInApproval is checked in the rejected/resubmitted/pending filter
    // branches below so this never leaks outside the approved state.
    { label: "Profile Update", value: "Profile Update", menuAccessName: 'Profile Update', meta: { onlyInApproval: true } },
    // { label: "Disable", value: "Disable",menuAccessName:'Disable' },
  ]);
  const [assignBenfitPlan, setAssignBenfitPlanModal] = useState(false);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [tabs, setTab] = useState(["CP", "FOS"]);
  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
    setShowDropDown(false);
    if (newValue === "CP") {
      setAllStatusDropDown((pre) => {
        pre = pre.map((m) => ({
          ...m,
          value: false,
        }));
        return [...pre];
      });
      setAllTypeDropDown((pre) => {
        pre = pre.map((m) => ({
          ...m,
          value: false,
        }));
        return [...pre];
      });
      setSelectedStatusArray([]);
      setSelectedTypeArray([]);
      setSelectedListDropDown([]);
      setPageNumber(0);
      setCP([]);
      setSearch("");
      setDrpDownSelectedVal("Latest First");

      setShowAllStatusDropDown(false);
      setShowTypeDropDown(false);
      setListOfDropDown((pre) => {
        pre = pre.map((m) => ({
          ...m,
          select: false,
        }));
        pre[0].select = true;
        return [...pre];
      });
      getCp(0, false, "", [], [], "Latest First");
    } else if (newValue === "FOS") {
      setSearchFos("");
      setPageNumberFos(0);
      setDrpDownSelectedVal("Latest First");
      getFos(
        0,
        false,
        "",
        selectedStatusArray,
        selectedTypeArray,
        "Latest First"
      );
    }
  };
  const [tabValue, setTabValue] = useState("CP");
  const [fos, setFos] = useState([]);
  const [totalFOSCount, setTotalFOSCount] = useState(0);

  // ── Mobile view ──
  // 820px matches the breakpoint used across this codebase (AllAllotments.jsx:252).
  // Everything below is additive: the desktop render path is untouched.
  const isMobile = useMediaQuery("(max-width:820px)");
  const [mobileDetailRow, setMobileDetailRow] = useState(null);
  const [mobileDetailDocs, setMobileDetailDocs] = useState(null);
  const [mobileFosDetailRow, setMobileFosDetailRow] = useState(null);
  const [mobileFosDetailDocs, setMobileFosDetailDocs] = useState(null);

  // FOS filters are kept separate from the CP ones. CP and FOS already share
  // selectedStatusArray/selectedTypeArray, and reusing those here would make
  // filtering one tab silently affect the other.
  const [fosStatusArray, setFosStatusArray] = useState([]);
  const [fosDatePreset, setFosDatePreset] = useState("all");
  const fosAppliedDatesRef = useRef({ start: null, end: null });

  // Desktop FOS filter dropdown. Deliberately separate from the CP dropdown's
  // state so nothing about the existing CP filter behaviour changes.
  const [showFosDropDown, setShowFosDropDown] = useState(false);
  const [fosFilterDimension, setFosFilterDimension] = useState("None");
  const [fosStatusOptions, setFosStatusOptions] = useState([
    { label: "Active", value: false },
    { label: "Disabled", value: false },
  ]);
  const [fosSelectDates, setFosSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [fosDateHelperText, setFosDateHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [fosSelectedListDropDown, setFosSelectedListDropDown] = useState([]);
  const [mobileActionSheet, setMobileActionSheet] = useState(null);
  const [mobileDatePreset, setMobileDatePreset] = useState("all");
  // Set once the user has gone through the "created with different name /
  // resubmitted" alert and opened the details. Desktop's equivalent is
  // ViewCPDetails opened with showStatusButton, whose Accept approves directly
  // without re-running the flag check -- without this, mobile looped back to
  // the same alert on every Approve and a flagged CP could never be approved.
  const [mobileReviewedCpId, setMobileReviewedCpId] = useState(null);
  // CP ids this session approved successfully from mobile. The resubmitted
  // flow approves first and then offers "View Details"; without this the
  // details opened from the alert still showed the pre-approval row with an
  // Approve button, inviting a second approval.
  const mobileApprovedIdsRef = useRef(new Set());
  // The initial (never-fetched) arrays. Every setCP/setFos creates a new
  // array, so "still the initial one" means the first fetch hasn't answered --
  // the mobile list shows Loading… instead of "No partners match" until then.
  const initialCpRef = useRef(cp);
  const initialFosRef = useRef(fos);

  // KYC documents are not on the row — getCp leaves kycDoc commented out.
  // Fetch them the same way ViewCPDetails does (ViewCPDetails.jsx:74-91),
  // including its isDeleted branch: KycDocuments rows are hard-deleted when a CP
  // is suspended, so the live table returns [] and the archived snapshot in
  // DeletedCpFos has to be read instead. Without this branch a suspended CP's
  // PAN / RERA / GST all showed "NA" on mobile while desktop showed them fine.
  // This mirrors the mobile FOS effect below, which already had the branch.
  // Keyed on the record's identity rather than the row object, so patching the
  // open row's status after an action doesn't refetch its documents.
  const mobileDetailCpId = mobileDetailRow?.cpId;
  const mobileDetailIsDeleted = mobileDetailRow?.isDeleted;
  useEffect(() => {
    if (!mobileDetailCpId) {
      setMobileDetailDocs(null);
      setMobileReviewedCpId(null);
      return;
    }
    let cancelled = false;
    const partition = (kycRes) => ({
      pan: (kycRes ?? []).find((el) => el.docType === "PanCard") ?? null,
      rera: (kycRes ?? []).find((el) => el.docType === "Rera") ?? null,
      gst: (kycRes ?? []).find((el) => el.docType === "GST") ?? null,
    });

    if (mobileDetailIsDeleted) {
      getDeletedCpData(mobileDetailCpId)
        .then((archived) => {
          if (cancelled) return;
          setMobileDetailDocs(partition(archived?.kycDocuments));
        })
        .catch((err) => {
          if (cancelled) return;
          console.log("Error while loading archived CP data", err);
          setMobileDetailDocs({ pan: null, rera: null, gst: null });
          showError("Error While loading archived CP data.Please try again later!");
        });
    } else {
      getKYCDocuments(mobileDetailCpId)
        .then((rows) => {
          if (cancelled) return;
          setMobileDetailDocs(partition(rows));
        })
        .catch((err) => {
          if (cancelled) return;
          console.log("Error while loading Documents", err);
          setMobileDetailDocs({ pan: null, rera: null, gst: null });
          showError("Error While loading Documents.Please try again later!");
        });
    }
    return () => {
      cancelled = true;
    };
  }, [mobileDetailCpId, mobileDetailIsDeleted]);

  // Same idea for the FOS detail page. Mirrors ViewFOSIDDetails.jsx:60-92,
  // including its isDeleted branch: KYC rows are hard-deleted when a FOS is
  // suspended, so the archived snapshot in DeletedCpFos is used instead.
  useEffect(() => {
    if (!mobileFosDetailRow?.fosId) {
      setMobileFosDetailDocs(null);
      return;
    }
    let cancelled = false;
    const partition = (kycRes) => ({
      pan: (kycRes ?? []).find((el) => el.docType === "PanCard") ?? null,
      aadhar: (kycRes ?? []).find((el) => el.docType === "AadharCard") ?? null,
    });

    if (mobileFosDetailRow.isDeleted) {
      getDeletedFosData(mobileFosDetailRow.fosId)
        .then((archived) => {
          if (cancelled) return;
          setMobileFosDetailDocs(partition(archived?.kycDocuments));
        })
        .catch((err) => {
          if (cancelled) return;
          console.log("Error while loading archived FOS data", err);
          setMobileFosDetailDocs({ pan: null, aadhar: null });
          showError("Error While loading archived FOS data.Please try again later!");
        });
    } else {
      getFOSKYCDocuments(mobileFosDetailRow.fosId)
        .then((kycRes) => {
          if (cancelled) return;
          setMobileFosDetailDocs(partition(kycRes));
        })
        .catch((err) => {
          if (cancelled) return;
          console.log("Error while loading Documents", err);
          setMobileFosDetailDocs({ pan: null, aadhar: null });
          showError("Error While loading Documents.Please try again later!");
        });
    }
    return () => {
      cancelled = true;
    };
  }, [mobileFosDetailRow]);

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  const [viewFOSIDDetailsModal, setViewFOSIDDetailsModal] = useState(false);

  // useEffect(() => {
  //   supabase.auth.api.deleteUser(JSON.parse(localStorage.getItem('supabase.auth.token')).currentSession.access_token,"82448c77-5bd6-4946-a36c-1d0fd47e3eef")
  // }, [])



  useEffect(() => {
    dispatch(action.activeMenu("channelpartner"));
    let tempSideMenuArray = [];
    console.log(Object.keys(loggedInUser?.roleId?.accessibleTabs?.Partners));
    tabs.forEach((el, index) => {
      if (
        Object.keys(loggedInUser?.roleId?.accessibleTabs?.Partners).includes(el)
      ) {
        console.log(el);
        if (
          loggedInUser?.roleId?.accessibleTabs?.Partners?.[el]?.isAccessible
        ) {
          console.log(el);
          tempSideMenuArray.push(el);
        }
      }
    });
    console.log(tempSideMenuArray);
    setTab([...tempSideMenuArray]);
    setTabValue(tempSideMenuArray[0]);
    if (tempSideMenuArray[0] === 'CP') {
      getCp(
        0,
        false,
        search,
        selectedStatusArray,
        selectedTypeArray,
        drpDownSelectedVal
      );
    }
    else if (tempSideMenuArray[0] === "FOS") {
      getFos(
        0,
        false,
        "",
        selectedStatusArray,
        selectedTypeArray,
        "Latest First"
      );
    }

    console.log(search);
  }, []);

  //snapShot
  // useEffect(() => {
  //   if (loggedInUser) {
  //     const updateStatusListenerForCP = supabase
  //       .from('CP')
  //       .on("UPDATE", (handleRecordUpdated) => {
  //         console.log({ handleRecordUpdated });
  //         if(handleRecordUpdated.new.approvalStatus==='resubmitted'){
  //           getCp(
  //             0,
  //             false,
  //             search,
  //             selectedStatusArray,
  //             selectedTypeArray,
  //             drpDownSelectedVal
  //           );
  //         }

  //       })
  //       .subscribe();
  //   }
  // }, []);

  const navigate = useNavigate();
  const [rejectResponse, setRejectResponse] = useState(false);
  const [statusButton, setStatusButton] = useState(false);
  // The CP suspend flow is a single modal: it runs the site-visit / allotment /
  // CP-payment checks, collects the mandatory note, and is itself the
  // confirmation step -- there is no separate "are you sure" alert in front.
  const [suspendSummaryOpen, setSuspendSummaryOpen] = useState(false);
  const [cpToSuspend, setCpToSuspend] = useState(null);
  const [suspendFosAlert, setSuspendFosAlert] = useState(false);
  const [fosToSuspend, setFosToSuspend] = useState(null);

  const [columns, setColumns] = useState([
    {
      field: "Action",
      headerName: "Action",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {params.row.Disabled ? <ThreeDotsMenu
              list={['Enable']}
              selectedValue={async (e) => {
                if (e === "Enable") await enableCp(params.row);
              }}
            /> : <ThreeDotsMenu
              list={params.row.tempSideMenuArrayCP.filter((each) => {
                // if(params.row.type==='Individual'&&each.meta?.hideForIndividual){
                //   return false
                // }
                if (params.row.approvalStatus === "disable") {
                  return each.value === "View Details";
                }
                if (params.row.approvalStatus === "approved") {
                  if (
                    params.row.approvalStatus !== each.value &&
                    (each.meta?.showInApproval ?? true)
                  ) {
                    return each.label;
                  }
                } else if (params.row.approvalStatus === "Profile Update") {
                  // Same options as approved (Suspend, View Details, etc.),
                  // minus Approve (doesn't apply) and minus Profile Update
                  // itself (already unlocked -- this status IS the
                  // double-unlock guard, re-showing the entry would defeat it).
                  if (each.value === "approved" || each.meta?.onlyInApproval) {
                    return false;
                  }
                  return each.meta?.showInApproval ?? true;
                } else if (params.row.approvalStatus === "rejected") {
                  if (each.meta?.onlyInApproval) return false;
                  if (params.row.approvalStatus !== each.value) {
                    return each.label;
                  }
                } else if (params.row.approvalStatus === "resubmitted") {
                  if (each.meta?.duplicate) return false;
                  if (each.meta?.onlyInApproval) return false;
                  return each.meta?.showInResubmitted ?? true;
                } else {
                  if (each.meta?.duplicate) return false;
                  if (each.meta?.onlyInApproval) return false;
                  return each.label;
                }
              })}
              selectedValue={(e) => {
                console.log(e);
                if (e.value === "rejected") {
                  if (e.label === "Suspend") {
                    setCpToSuspend(params.row);
                    setSuspendSummaryOpen(true);
                  } else {
                    setViewData(params.row);
                    setRejectResponse(true);
                  }
                } else if (e.value === "approved") {
                  setViewData(params.row);
                  console.log(params.row.isFlagged);
                  // approvedStatus(params.row.id);
                  if (params.row.isFlagged) {
                    setStatusButton(true);
                    setDisplayMessage(
                      "This User is created with Different Name.View Details"
                    );
                    setOpenConfirmation(true);
                  } else {
                    approvedStatus(params.row.id);
                  }
                  if (params.row.approvalStatus === "resubmitted") {
                    setOpenConfirmation(true);
                    setDisplayMessage("This User has resubmited his data");
                    setStatusButton(true);
                  }
                } else if (e.value === "View Details") {
                  setStatusButton(false);
                  setViewData(params.row);
                  setViewCPDetailsModal(true);
                } else if (e.value === "Assign Benefit Plan") {
                  setAssignBenfitPlanModal(true);
                  setViewData(params.row);
                } else if (e.value === "View FOS Details") {
                  setViewFOSDetailsModal(true);
                  setViewData(params.row);
                } else if (e.value === "Reset Password") {
                  setViewData(params.row);
                  console.log("params.row.email: ", params.row.email);
                  // sendResetPasswordMail('vedashree.l@htstechsolutions.com').then((resp) => {
                  sendResetPasswordMailCP(params.row.email)
                    .then((resp) => {
                      console.log("resp: ", resp);
                      showSuccess(
                        "Reset password link sent successfully to " +
                        params.row.billingName +
                        "( " +
                        params.row.email +
                        " )"
                      );
                    })
                    .catch((err) => {
                      console.log("err: ", err);
                      showError(
                        "Could not send reset password link to " +
                        params.row.billingName
                      );
                    });
                  // sendResetPasswordMail(params.row.email);
                } else if (e.value === "Disable") {
                  console.log("Disable", params.row.cpId)
                  CheckCpIdExists(params.row.cpId).then(async (DisplayIdResp) => {
                    // console.log("DisplayId-->" , DisplayIdResp)
                    if (DisplayIdResp.length === 0) {
                      const { data, error } = await supabase
                        .from("CpContactPerson")
                        .update({ isDisabled: true })
                        .eq("cpId", params.row.cpId);
                      if (data) {
                        dismissLoader();
                        console.log(data);
                        //*delete auth api
                        deleteAuthByEmail(params.row.email).then((AuthDeleteResp) => {
                          console.log("AuthDeleteResp", AuthDeleteResp)
                          showSuccess(`${data[0].name} was disabled successFully!`)
                          getCp(
                            0,
                            false,
                            search,
                            selectedStatusArray,
                            selectedTypeArray,
                            drpDownSelectedVal
                          );
                        }).catch((err) => {
                          console.error("deleteAuthByEmail-CP", err)
                        })

                      } else throw error;
                    } else if (DisplayIdResp.length > 0) {
                      showError("Cannot Disable as Leads already exists!")
                    }
                  }).catch((err) => {
                    console.error("CheckCpDisplayIdExists", err)
                  })
                } else if (e.value === "Profile Update") {
                  presentLoader();
                  unlockCpProfileForEdit(params.row.cpId, loggedInUser.id)
                    .then((res) => {
                      dismissLoader();
                      if (res.blocked) {
                        showError(res.message);
                        return;
                      }
                      showSuccess(`Profile editing unlocked for ${params.row.billingName}.`);
                      getCp(
                        pageNumber,
                        false,
                        search,
                        selectedStatusArray,
                        selectedTypeArray,
                        drpDownSelectedVal
                      );
                    })
                    .catch((err) => {
                      dismissLoader();
                      console.error("unlockCpProfileForEdit", err);
                      showError("Failed to unlock profile editing.");
                    });
                }
              }}
            />}
          </div>

          // <div className={cssClasses.wrapperActions}>
          //   {params.row.approvalStatus === "approved" || params.row.cpId.approvalStatus === "resubmitted"||
          //   params.row.cpId.approvalStatus === "pending" ? (
          //     <Button
          //       style={{
          //         color: "#1570EF",
          //         backgroundColor: "#FFF",
          //         border: "1px solid #1570EF",
          //         fontSize: "1.4rem",
          //         lineHeight: "2rem",
          //         padding: "0.5rem 0.6rem",
          //       }}
          //       disable={params.row.cpId.approvalStatus === "rejected"}
          //       btnName={"Reject"}
          //       clicked={() => {
          //         setViewData(params.row);
          //         setRejectResponse(true);
          //       }}
          //     />
          //   ) : (
          //     ""
          //   )}
          //   {params.row.cpId.approvalStatus === "rejected" || params.row.cpId.approvalStatus === "resubmitted"||
          //   params.row.cpId.approvalStatus === "pending" ? (
          //     <Button
          //       style={{
          //         color: "#FFF",
          //         backgroundColor: "#1570EF",
          //         border: "1px solid #1570EF",
          //         fontSize: "1.4rem",
          //         lineHeight: "2rem",
          //         padding: "0.5rem 0.6rem",
          //       }}
          //       btnName={"Accept"}
          //       clicked={() => {
          //         setViewData(params.row);
          //         console.log(params.row.cpId.isFlagged);
          //         // approvedStatus(params.row.id);
          //         if (params.row.cpId.isFlagged) {
          //           setStatusButton(true);
          //           setDisplayMessage("This User is created with Different Name.View Details");
          //           setOpenConfirmation(true);
          //         } else {
          //           approvedStatus(params.row.id);
          //         }
          //         if(params.row.cpId.approvalStatus==='resubmitted'){

          //           setOpenConfirmation(true);
          //           setDisplayMessage("This User has resubmited his data");
          //           setStatusButton(true);
          //         }
          //       }}
          //     />
          //   ) : (
          //     ""
          //   )}
          //   {params.row.cpId.approvalStatus === "rejected" ||
          //   params.row.cpId.approvalStatus === "approved" ? (
          //     <Button
          //       style={{
          //         color: "#1570EF",
          //         backgroundColor: "#FFF",
          //         border: "1px solid #1570EF",
          //         fontSize: "1.4rem",
          //         lineHeight: "2rem",
          //         padding: "0.5rem 0.6rem",
          //       }}
          //       btnName={"View Details"}
          //       clicked={() => {
          //         setStatusButton(false);
          //         setViewData(params.row);
          //         setViewCPDetailsModal(true);
          //       }}
          //     />
          //   ) : (
          //     ""
          //   )}
          // </div>
        );
      },
    },
    {
      field: "cpDisplayId",
      headerName: "CPID",
      width: 220,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className={cssClasses.wrapperSecondColumn}>
            <div
              title={params.row.cpDisplayId}
              className={cssClasses.cpDisplayId}
            >
              {params.row.cpDisplayId}
            </div>
            {params.row.Disabled ?
              <LeadStatusChip
                style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                label={"Disabled"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              /> : <>
                {params.row.approvalStatus === "pending" && (
                  <LeadStatusChip
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {params.row.approvalStatus === "approved" && (
                  <LeadStatusChip
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {params.row.approvalStatus === "rejected" && (
                  <LeadStatusChip
                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {params.row.approvalStatus === "resubmitted" && (
                  <LeadStatusChip
                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {params.row.approvalStatus === "Profile Update" && (
                  <LeadStatusChip
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
                {params.row.approvalStatus === "disable" && (
                  <LeadStatusChip
                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                    label={params.row.approvalStatus}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
              </>
            }


          </div>
        );
      },
    },
    {
      field: "type",
      headerName: "Type",
      width: 150,
      sortable: false,
    },

    {
      field: "name",
      headerName: "Contact Person Name",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        return (
          <div title={params.row.name} className={cssClasses.names}>
            {params.row.name}
          </div>
        );
      },
    },
    {
      field: "billingName",
      headerName: "Billing Name",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        return (
          <div title={params.row.billingName} className={cssClasses.names}>
            {params.row.billingName}
          </div>
        );
      },
    },
    {
      field: "ledgerSyncStatus",
      headerName: "Ledger Sync Status",
      width: 200,
      sortable: false,
      renderCell: (params) => {
        const sync = getLedgerSyncStatus(params.row);
        return (
          <div className={cssClasses.wrapperSecondColumn}>
            <LeadStatusChip
              style={{ color: sync.color, backgroundColor: sync.backgroundColor }}
              label={sync.label}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
            <div
              title="Finance / CRM ledger status"
              style={{ fontSize: "1.1rem", color: "#667085", marginTop: "0.3rem" }}
            >
              Finance {sync.financeOk ? "✓" : "—"} · CRM {sync.crmOk ? "✓" : "—"}
            </div>
          </div>
        );
      },
    },

    {
  field: "createdAt",
  headerName: "Created At",
  width: 300,
  sortable: false,
  renderCell: (params) => {
    const formattedDate = formatDate(params.row.createdAt);

    return (
      <div title={formattedDate} className={cssClasses.names}>
        {formattedDate}
      </div>
    );
  },
},
   {
  field: "lastUpdated",
  headerName: "Last Updated",
  width: 300,
  sortable: false,
  renderCell: (params) => {
    const formattedDate = formatDate(params.row.lastUpdated);

    return (
      <div title={formattedDate} className={cssClasses.names}>
        {formattedDate}
      </div>
    );
  },
}

    // {
    //   field: "Action",
    //   headerName: "Action",
    //   width: 300,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <div className={cssClasses.wrapperActions}>
    //         {params.row.cpId.approvalStatus === "approved" || params.row.cpId.approvalStatus === "resubmitted"||
    //         params.row.cpId.approvalStatus === "pending" ? (
    //           <Button
    //             style={{
    //               color: "#1570EF",
    //               backgroundColor: "#FFF",
    //               border: "1px solid #1570EF",
    //               fontSize: "1.4rem",
    //               lineHeight: "2rem",
    //               padding: "0.5rem 0.6rem",
    //             }}
    //             disable={params.row.cpId.approvalStatus === "rejected"}
    //             btnName={"Reject"}
    //             clicked={() => {
    //               setViewData(params.row);
    //               setRejectResponse(true);
    //             }}
    //           />
    //         ) : (
    //           ""
    //         )}
    //         {params.row.cpId.approvalStatus === "rejected" || params.row.cpId.approvalStatus === "resubmitted"||
    //         params.row.cpId.approvalStatus === "pending" ? (
    //           <Button
    //             style={{
    //               color: "#FFF",
    //               backgroundColor: "#1570EF",
    //               border: "1px solid #1570EF",
    //               fontSize: "1.4rem",
    //               lineHeight: "2rem",
    //               padding: "0.5rem 0.6rem",
    //             }}
    //             btnName={"Accept"}
    //             clicked={() => {
    //               setViewData(params.row);
    //               console.log(params.row.cpId.isFlagged);
    //               // approvedStatus(params.row.id);
    //               if (params.row.cpId.isFlagged) {
    //                 setStatusButton(true);
    //                 setDisplayMessage("This User is created with Different Name.View Details");
    //                 setOpenConfirmation(true);
    //               } else {
    //                 approvedStatus(params.row.id);
    //               }
    //               if(params.row.cpId.approvalStatus==='resubmitted'){

    //                 setOpenConfirmation(true);
    //                 setDisplayMessage("This User has resubmitted his data");
    //                 setStatusButton(true);
    //               }
    //             }}
    //           />
    //         ) : (
    //           ""
    //         )}
    //         {params.row.cpId.approvalStatus === "rejected" ||
    //         params.row.cpId.approvalStatus === "approved" ? (
    //           <Button
    //             style={{
    //               color: "#1570EF",
    //               backgroundColor: "#FFF",
    //               border: "1px solid #1570EF",
    //               fontSize: "1.4rem",
    //               lineHeight: "2rem",
    //               padding: "0.5rem 0.6rem",
    //             }}
    //             btnName={"View Details"}
    //             clicked={() => {
    //               setStatusButton(false);
    //               setViewData(params.row);
    //               setViewCPDetailsModal(true);
    //             }}
    //           />
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //       // <div className={cssClasses.wrapperActions}>
    //       //   <ThreeDotsMenu
    //       //     list={menuItems.filter((el) => {
    //       //       if (
    //       //         el === "Accept" &&
    //       //         params.row.cpId.approvalStatus === "approved"
    //       //       ) {
    //       //         return false;
    //       //       } else if (
    //       //         el === "Reject" &&
    //       //         params.row.cpId.approvalStatus === "rejected"
    //       //       ) {
    //       //         return false;
    //       //       }
    //       //       return true;
    //       //     })}
    //       //     selectedValue={(value) => {
    //       //       console.log(value);
    //       //       if (value === "Accept") {
    //       //         updateStatus(params.row.id, "approved")
    //       //           .then((res) => {
    //       //             insertCpLogs(params.row.id, "approved", loggedInUser.id)
    //       //               .then((resp) => {
    //       //                 getCp(pageNumber,false);
    //       //               })
    //       //               .catch((err) => {
    //       //                 showError(err);
    //       //               });
    //       //             console.log(res);
    //       //           })
    //       //           .catch((err) => {
    //       //             showError(err.message);
    //       //           });
    //       //       } else if (value === "Reject") {
    //       //         updateStatus(params.row.id, "rejected")
    //       //           .then((res) => {
    //       //             insertCpLogs(params.row.id, "rejected", loggedInUser.id)
    //       //               .then((resp) => {
    //       //                 console.log(resp);
    //       //                 getCp(pageNumber,false);
    //       //               })
    //       //               .catch((err) => {
    //       //                 showError(err);
    //       //               });
    //       //             console.log(res);
    //       //           })
    //       //           .catch((err) => {
    //       //             showError(err.message);
    //       //           });
    //       //       } else if (value === "View Details") {
    //       //         setViewData(params.row);
    //       //         setViewCPDetailsModal(true);
    //       //       }
    //       //     }}
    //       //   />
    //       // </div>
    //     );
    //   },
    // },
  ]);


  // Lifted verbatim out of the CP Action column's renderCell so both the
  // desktop grid and the mobile action sheet can call it. Only `params.row`
  // became `row`; the sequence of side effects is unchanged.
  // `reload` is passed only by the mobile view (to refetch with its paging
  // reset); desktop omits it and keeps its original refresh.
  async function enableCp(row, reload) {
    const authReSignUpCPResponse = await authSignUp({
      email: row.email,
      password: "12345",
    });
    if (!authReSignUpCPResponse.user) return;

    const message = `<h4>Hello ${row.name}</h4></br>
                    <p>You have successfully registered with us and here are your login credentials.</p>
                    <p>User ID: <b>${"CPID" + row.cpDisplayId}</b></p></br>
                    <p>Password <b>12345</b></p>
                    <p>Regards,</p>
                    <p>Vilas Javdekar Developers</p>`;
    sendMail(row.email, "Registered Successfully", message);

    const messageBody = {
      number: row.contactNumber,
      message: `Hello ${row.name}\nYou have successfully registered with us and here are your login credentials.\nUser ID FOSID${row.cpDisplayId}\nPassword 12345\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
      is_international_number:
        row.contactNumber.toString().substring(1, 3) !== "91",
    };
    sendMessage(messageBody).catch((err) => {
      console.log(err.message);
    });

    const { data, error } = await supabase
      .from("CpContactPerson")
      .update({ isDisabled: false })
      .eq("cpId", row.cpId);
    if (!data) throw error;

    dismissLoader();
    const { dataOfCp, error: cpError } = await supabase
      .from("CP")
      .update({ isPasswordUpdated: false })
      .eq("cpId", row.cpId);
    if (!dataOfCp) throw cpError;

    dismissLoader();
    showSuccess(`${data[0].name} was enabled successFully!`);
    if (reload) {
      reload();
      return;
    }
    getCp(
      0,
      false,
      search,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal
    );
  }

  // Same extraction for the FOS Action column.
  async function enableFos(row) {
    const authReSignUpFosResponse = await authSignUp({
      email: row.email,
      password: "12345",
    });
    if (!authReSignUpFosResponse.user) return;

    const message = `<h4>Hello ${row.name}</h4></br>
                     <p>You have successfully registered with us and here are your login credentials.</p>
                     <p>User ID: <b>${"FOSID" + row.fosDisplayId}</b></p></br>
                     <p>Password <b>12345</b></p>
                     <p>Regards,</p>
                     <p>Vilas Javdekar Developers</p>`;
    sendMail(row.email, "Registered Successfully", message);

    const messageBody = {
      number: row.contactNumber,
      message: `Hello ${row.name}\nYou have successfully registered with us and here are your login credentials.\nUser ID FOSID${row.fosDisplayId}\nPassword 12345\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
      is_international_number:
        row.contactNumber.toString().substring(1, 3) !== "91",
    };
    sendMessage(messageBody).catch((err) => {
      console.log(err.message);
    });

    const { data, error } = await supabase
      .from("FOS")
      .update({ isDisabled: false, isPasswordUpdated: false })
      .eq("fosId", row.fosId);
    if (!data) throw error;

    dismissLoader();
    showSuccess(`${data[0].name} was enabled successFully!`);
    getFos(0, false, "", selectedStatusArray, selectedTypeArray, "Latest First");
  }

  function sendMail(email, subject, message) {
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    console.log('body: ', body);
    sendMailTo(body).then((resp) => {
      console.log(resp);
    })
      .catch((err) => {
        console.log(err);
      });
  }
  const [fosColumn, setFosColumn] = useState([
    {
      field: "Action",
      headerName: "Action",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {params.row.isDisabled ? <ThreeDotsMenu
              list={['View Details']}
              selectedValue={async (e) => {
                if (e === "Enable") {
                  await enableFos(params.row);
                } else if (e === "View Details") {
                  setViewData(params.row);
                  setViewFOSIDDetailsModal(true);
                }
              }} /> : <ThreeDotsMenu
              list={
                params.row.approvalStatus === "disable"
                  ? params.row.fosThreeDotsMenu.filter(
                      (item) => item === "View Details"
                    )
                  : params.row.fosThreeDotsMenu
              }
              selectedValue={(e) => {
                console.log(e);
                if (e === "Reset Password") {
                  console.log("params.row.email: ", params.row.email);
                  // sendResetPasswordMail('vedashree.l@htstechsolutions.com').then((resp) => {
                  sendResetPasswordMailCP(params.row.email)
                    .then((resp) => {
                      console.log("resp: ", resp);
                      showSuccess(
                        "Reset password link sent successfully to " +
                        params.row.name +
                        "( " +
                        params.row.email +
                        " )"
                      );
                    })
                    .catch((err) => {
                      console.log("err: ", err);
                      showError(
                        "Could not send reset password link to " +
                        params.row.billingName
                      );
                    });
                  // sendResetPasswordMail(params.row.email);
                } else if (e === "Disable") {
                  console.log("Disable", params.row)
                  CheckFosIdExists(params.row.fosId).then(async (DisplayIdResp) => {
                    // console.log("DisplayId-->" , DisplayIdResp)
                    if (DisplayIdResp.length === 0) {
                      const { data, error } = await supabase
                        .from("FOS")
                        .update({ isDisabled: true })
                        .eq("fosId", params.row.fosId);
                      if (data) {

                        dismissLoader();
                        console.log(data);
                        //*delete auth api here
                        deleteAuthByEmail(params.row.email).then((AuthResp) => {
                          console.log("AuthResp", AuthResp)
                          showSuccess(`${data[0].name} was disabled successFully!`)
                          getFos(
                            0,
                            false,
                            "",
                            selectedStatusArray,
                            selectedTypeArray,
                            "Latest First"
                          );
                        }).catch((err) => {
                          console.error("deleteAuthByEmail", err)
                        })


                      } else throw error;
                    } else if (DisplayIdResp.length > 0) {
                      showError(`Cannot Disable as Leads already exists!`)
                    }
                  }).catch((err) => {
                    console.error("CheckCpDisplayIdExists", err)
                  })
                } else if (e === "View Details") {
                  setViewData(params.row);
                  setViewFOSIDDetailsModal(true);
                } else if (e === "Suspend") {
                  setFosToSuspend(params.row);
                  setSuspendFosAlert(true);
                }
              }}
            />}
          </div>

        );
      },
    },
    {
      field: "cpDisplayId",
      headerName: "FoSID",
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className={cssClasses.wrapperSecondColumn}>
            <div
              title={params.row.cpDisplayId}
              className={cssClasses.fosDisplayId}
            >
              FOSID{params.row.fosDisplayId}
            </div>
            {params.row.isDisabled ? <LeadStatusChip
              style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
              label={"Disabled"}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            /> : <>
              {params.row.approvalStatus === "pending" && (
                <LeadStatusChip
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  label={params.row.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {params.row.approvalStatus === "approved" && (
                <LeadStatusChip
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  label={params.row.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {params.row.approvalStatus === "rejected" && (
                <LeadStatusChip
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                  label={params.row.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {params.row.approvalStatus === "resubmitted" && (
                <LeadStatusChip
                  style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  label={params.row.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {params.row.approvalStatus === "Profile Update" && (
                <LeadStatusChip
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  label={params.row.approvalStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
            </>}

          </div>
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 300,
      sortable: false,
    },
    {
      field: "cpName",
      headerName: "CP",
      width: 300,
      sortable: false,
      // renderCell: (params) => {
      //   return (
      //     <div title={params.row.billingName} className={cssClasses.names}>
      //       {params.row.billingName}
      //     </div>
      //   );
      // },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        const formattedDate = formatDate(params.row.createdAt);

        return (
          <div title={formattedDate} className={cssClasses.names}>
            {formattedDate}
          </div>
        );
      },
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        const formattedDate = formatDate(params.row.lastUpdated);

        return (
          <div title={formattedDate} className={cssClasses.names}>
            {formattedDate}
          </div>
        );
      },
    },
  ]);
  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    setPageNumber(0);
    setCP([]);
    getCp(
      0,
      false,
      e.target.value,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal
    );
  }, 800);
  const debouncedFetchSearchDataFos = debounce((e) => {
    setSearchFos(e.target.value);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      e.target.value,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal
    );
  }, 800);
  function getCp(
    pageNumber,
    merge,
    search,
    selectedStatusArray,
    selectedTypeArray,
    drpDownSelectedVal,
    // Omit to reuse the applied created-on range; pass one explicitly from
    // Apply/Clear, which need the new value before state has committed.
    dateRange
  ) {
    const range = dateRange === undefined ? appliedDatesRef.current : dateRange;
    // ,selectedStatusArray, selectedTypeArray,drpDownSelectedVal
    // setCP([]);
    Network.getStatus().then((status) => {
      if (status.connected) {
        // getAllCp(
        //   pageNumber * pageSize,
        //   pageNumber * pageSize + pageSize - 1,
        //   search,
        //   selectedStatusArray,
        //   selectedTypeArray,
        //   drpDownSelectedVal
        // )
        //   .then((resp) => {
        //     //filter to get CP not null
        //     let data = resp.data.filter(({ cpId }) => cpId !== null);
        //     console.log({ data });
        //     console.log(resp);
        //     setTotalCount(resp.count);
        //     resp = data.map((el, index) => ({
        //       ...el,
        //       id: el.cpId.cpId,
        //       cpDisplayId:
        //         "CPID" +
        //         el.cpId.cpDisplayId.replace(
        //           el.cpId.cpDisplayId.substring(8, 12),
        //           "-" + el.cpId.cpDisplayId.substring(8, 12)
        //         ),
        //       index: index,
        //       type: el.cpId.cpType,
        //       kycDoc: el.cpId.KycDocuments,
        //       billingName: el.cpId.billingName,
        //       recommendedBySalesId: el?.cpId?.recommendedBySalesId?.name??'-',
        //     }));
        //     if (merge) {
        //       setCP((pre) => [...pre, ...resp]);
        //     } else {
        //       setCP([...resp]);
        //     }
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
        let tempSideMenuArray = [];
        // !!To check three dots menu user access
        console.log(Object.keys(loggedInUser?.roleId?.accessibleTabs?.Partners?.CP));
        menuArray.forEach((el, index) => {
          if (
            Object.keys(loggedInUser?.roleId?.accessibleTabs?.Partners?.CP).includes(el.menuAccessName)
          ) {
            if (
              loggedInUser?.roleId?.accessibleTabs?.Partners?.['CP']?.[el.menuAccessName]?.isAccessible
            ) {
              tempSideMenuArray.push(el);
            }
          }
        });
        getAllCpFromCpTable(
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          // pageNumber * pageSize + pageSize - 1,
          search,
          selectedStatusArray,
          selectedTypeArray,
          drpDownSelectedVal,
          range?.start ?? null,
          range?.end ?? null
        ).then((resp) => {
          setTotalCount(resp.count);
          const cpArr = resp.data.map((el, index) => ({
            ...el,
            id: el.cpId,
            // Suspending a CP hard-deletes its CpContactPerson row, so for a
            // suspended CP the contact details exist only in the DeletedCpFos
            // snapshot. name already branched on isDeleted; contactNumber and
            // email did not, which is why a suspended CP showed the literal
            // string "+undefined" for phone and a blank email.
            name: el.isDeleted ? el?.DeletedCpFos?.[0]?.contactName : el?.CpContactPerson[0]?.name,
            contactNumber: formatCpContactNumber(
              el.isDeleted
                ? el?.DeletedCpFos?.[0]?.contactNumber
                : el?.CpContactPerson[0]?.contactNumber
            ),
            email: el.isDeleted
              ? el?.DeletedCpFos?.[0]?.contactEmail
              : el?.CpContactPerson[0]?.email,
            cpDisplayId: "CPID" + el.cpDisplayId,
            createdAt: el.created_at,  
            lastUpdated: el.last_updated_at,
            // "CPID" +
            // el.cpDisplayId.replace(
            //   el.cpDisplayId.substring(8, 12),
            //   "-" + el.cpDisplayId.substring(8, 12)
            // ),
            index: index,
            Disabled: el?.CpContactPerson[0]?.isDisabled,
            type: el.cpType,
            // kycDoc: el.KycDocuments,
            billingName: el.billingName,
            recommendedBySalesId: el?.recommendedBySalesId?.name ?? "NA",
            cpSourcingName: el?.cpSourceId?.name ?? "NA",
            tempSideMenuArrayCP: tempSideMenuArray
          }));
          console.log("cp before set", cpArr);
          if (merge) {
            setCP((pre) => [...pre, ...cpArr]);
          } else {
            setCP([...cpArr]);
          }
        });
      } else {
        showInfo("You're offline. Please check your internet connection!");
      }
    });
  }
  function getFos(
    pageNumber,
    merge,
    search,
    selectedStatusArray,
    selectedTypeArray,
    drpDownSelectedVal,
    // Additive, and both optional so every existing caller is unaffected.
    // Omit dateRange to reuse the applied range, matching getCp's convention.
    dateRange,
    fosStatuses
  ) {
    const fosRange =
      dateRange === undefined ? fosAppliedDatesRef.current : dateRange;
    const fosStatusList =
      fosStatuses === undefined ? fosStatusArray : fosStatuses;

    Network.getStatus().then((status) => {
      if (status.connected) {

        getAllFOSFromTable(
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          // pageNumber * pageSize + pageSize - 1,
          search,
          selectedStatusArray,
          selectedTypeArray,
          drpDownSelectedVal,
          fosRange?.start ?? null,
          fosRange?.end ?? null,
          fosStatusList
        ).then((resp) => {
          console.log("fos", resp);
          setTotalFOSCount(resp.count);
          const fosArr = resp.data.map((el, index) => ({
            ...el,
            id: el.fosId,
            cpName: el?.cpId?.billingName,
            // Same aliases getCp creates, so the Created At / Last Updated
            // columns and the detail page read the field names they expect.
            createdAt: el.created_at,
            lastUpdated: el.last_updated_at,
            fosThreeDotsMenu: ['View Details', 'Suspend'],
          }));
          if (
            loggedInUser?.roleId?.accessibleTabs?.Partners?.["FOS"]?.[
              "Reset Password"
            ]?.isAccessible
          ) {
            fosArr.forEach((el) => {
              el.fosThreeDotsMenu.push("Reset Password");
              // el.fosThreeDotsMenu.push("Disable");
            });
          }
          if (merge) {
            setFos((pre) => [...pre, ...fosArr]);
          } else {
            setFos([...fosArr]);
          }
        });
      } else {
        showInfo("You're offline. Please check your internet connection!");
      }
    });
  }
  function getMoreFosData(passPageNumber) {
    setPageNumberFos(passPageNumber);
    getFos(
      passPageNumber,
      true,
      search,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal
    );
    // drpDownSelectedVal
  }
  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getCp(
      passPageNumber,
      true,
      search,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal
    );
    // drpDownSelectedVal
  }
  // `reload` is passed only by the mobile view; desktop omits it and keeps the
  // original refresh below.
  function approvedStatus(rowId, reload) {
    updateStatus(rowId, "approved", "")
      .then((res) => {
        console.log("res", res)
        // CreateNewBroker(res[0].cpId).then((BrokerResp) => {
        //   console.log("BrokerResp" , BrokerResp)
        // }).catch((err) => {
        //   console.error("BrokerResp" , err)
        // })
        // Push the approved CP into its sourcing user's SmartFlo contact group
        // (fire-and-forget — approval must not fail on telephony sync).
        uploadCpToContactGroup(rowId).catch((err) => {
          console.error("uploadCpToContactGroup failed", err?.response?.data || err.message);
        });
        insertCpLogs(rowId, "approved", loggedInUser.id)
          .then((resp) => {
            if (reload) {
              reload();
              return;
            }
            getCp(
              pageNumber,
              false,
              "",
              selectedStatusArray,
              selectedTypeArray,
              drpDownSelectedVal
            );
          })
          .catch((err) => {
            showError(err.message);
          });
        // console.log(res);
      })
      .catch((err) => {
        showError(err.message);
      })
      .catch((err) => {
        showError(err.message);
      });
  }
  function cpRejected(value) {
    setCP([]);
    setPageNumber(0);
    if (value) {
      getCp(
        0,
        false,
        search,
        selectedStatusArray,
        selectedTypeArray,
        drpDownSelectedVal
      );
    }
  }

  // ══ Mobile handlers ══
  // Every one delegates to the same functions the DataGrid columns call, so
  // behaviour and role gating stay identical to desktop.

  function mobileApplyFilters({ statuses, types, datePreset, range }) {
    setSelectedStatusArray(statuses);
    setSelectedTypeArray(types);
    setMobileDatePreset(datePreset);
    appliedDatesRef.current = { start: range.start, end: range.end };
    setPageMaintain(0);
    setPageNumber(0);
    getCp(0, false, search, statuses, types, drpDownSelectedVal, range);
  }

  function mobileClearFilters() {
    setSelectedStatusArray([]);
    setSelectedTypeArray([]);
    setMobileDatePreset("all");
    appliedDatesRef.current = { start: null, end: null };
    setPageMaintain(0);
    setPageNumber(0);
    getCp(0, false, search, [], [], drpDownSelectedVal, { start: null, end: null });
  }

  function mobileRemoveFilterTag(tag) {
    let statuses = selectedStatusArray;
    let types = selectedTypeArray;
    let range = appliedDatesRef.current;

    if (tag.dimension === "status") {
      statuses = selectedStatusArray.filter((s) => s !== tag.value);
      setSelectedStatusArray(statuses);
    } else if (tag.dimension === "type") {
      types = selectedTypeArray.filter((t) => t !== tag.value);
      setSelectedTypeArray(types);
    } else if (tag.dimension === "date") {
      setMobileDatePreset("all");
      range = { start: null, end: null };
      appliedDatesRef.current = range;
    }

    setPageMaintain(0);
    setPageNumber(0);
    getCp(0, false, search, statuses, types, drpDownSelectedVal, range);
  }

  // Desktop FOS filter: commit the checkbox + date selections and refetch.
  // Whole-day bounds, exactly as the CP Apply button does.
  function applyFosDesktopFilters() {
    if (fosSelectDates[0].value && !fosSelectDates[1].value) {
      setFosDateHelperText((pre) => ({
        ...pre,
        endDate: "Please Select end Date",
      }));
      return;
    }

    const statuses = fosStatusOptions.filter((o) => o.value).map((o) => o.label);
    const range = {
      start: fosSelectDates[0].value
        ? startOfDayMs(fosSelectDates[0].value)
        : null,
      end: fosSelectDates[1].value ? endOfDayMs(fosSelectDates[1].value) : null,
    };

    setFosStatusArray(statuses);
    fosAppliedDatesRef.current = range;
    setFosDatePreset(range.start || range.end ? "custom" : "all");
    setFosDateHelperText({ startDate: "", endDate: "" });
    setShowFosDropDown(false);
    setPageMaintainFos(0);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      searchFos,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal,
      range,
      statuses
    );
  }

  function clearFosDesktopFilters() {
    setFosStatusOptions((pre) => pre.map((o) => ({ ...o, value: false })));
    setFosSelectDates([
      { label: "StartDate", value: "" },
      { label: "EndDate", value: "" },
    ]);
    setFosDateHelperText({ startDate: "", endDate: "" });
    setFosSelectedListDropDown([]);
    setFosFilterDimension("None");
    setFosStatusArray([]);
    setFosDatePreset("all");
    fosAppliedDatesRef.current = { start: null, end: null };
    setShowFosDropDown(false);
    setPageMaintainFos(0);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      searchFos,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal,
      { start: null, end: null },
      []
    );
  }

  // FOS equivalents of the CP filter handlers, same staging and reset rules.
  function mobileApplyFosFilters({ statuses, datePreset, range }) {
    setFosStatusArray(statuses);
    setFosDatePreset(datePreset);
    fosAppliedDatesRef.current = { start: range.start, end: range.end };
    setPageMaintainFos(0);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      searchFos,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal,
      range,
      statuses
    );
  }

  function mobileClearFosFilters() {
    setFosStatusArray([]);
    setFosDatePreset("all");
    fosAppliedDatesRef.current = { start: null, end: null };
    setPageMaintainFos(0);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      searchFos,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal,
      { start: null, end: null },
      []
    );
  }

  function mobileRemoveFosFilterTag(tag) {
    let statuses = fosStatusArray;
    let range = fosAppliedDatesRef.current;

    if (tag.dimension === "status") {
      statuses = fosStatusArray.filter((s) => s !== tag.value);
      setFosStatusArray(statuses);
    } else if (tag.dimension === "date") {
      setFosDatePreset("all");
      range = { start: null, end: null };
      fosAppliedDatesRef.current = range;
    }

    setPageMaintainFos(0);
    setPageNumberFos(0);
    setFos([]);
    getFos(
      0,
      false,
      searchFos,
      selectedStatusArray,
      selectedTypeArray,
      drpDownSelectedVal,
      range,
      statuses
    );
  }

  function mobileSort(value) {
    setDrpDownSelectedVal(value);
    setPageMaintain(0);
    setPageNumber(0);
    setPageMaintainFos(0);
    setPageNumberFos(0);
    if (tabValue === "CP") {
      setCP([]);
      getCp(0, false, search, selectedStatusArray, selectedTypeArray, value);
    } else {
      setFos([]);
      getFos(0, false, searchFos, selectedStatusArray, selectedTypeArray, value);
    }
  }

  // Search and tab-change reset the row arrays but leave pageMaintain alone —
  // harmless for the DataGrid, but the mobile list slices by page, so a stale
  // index would slice past the end of a freshly-reset list and render nothing.
  // Wrapped here rather than fixing the shared handlers, to leave desktop as is.
  function mobileSearch(e) {
    setPageMaintain(0);
    debouncedFetchSearchData(e);
  }

  function mobileSearchFos(e) {
    setPageMaintainFos(0);
    debouncedFetchSearchDataFos(e);
  }

  function mobileTabChange(event, newValue) {
    setPageMaintain(0);
    setPageMaintainFos(0);
    tabChange(event, newValue);
  }

  // Page-by-page, mirroring the desktop DataGrid: cp/fos accumulate every
  // fetched page, and the list renders only the current page's slice. A page
  // that's already in memory needs no fetch; a new one does.
  function mobilePageChange(nextPage) {
    setPageMaintain(nextPage);
    if (pageNumber < nextPage) getMoreData(nextPage);
  }

  // Not getMoreFosData: that one sends the CP search term, so page 2+ of a
  // FOS search came back unfiltered.
  function mobilePageChangeFos(nextPage) {
    setPageMaintainFos(nextPage);
    if (pageNumberFos < nextPage) {
      setPageNumberFos(nextPage);
      getFos(
        nextPage,
        true,
        searchFos,
        selectedStatusArray,
        selectedTypeArray,
        drpDownSelectedVal
      );
    }
  }

  // Refetch after a row action. Every action's refresh replaces the rows with
  // page 0 only, so the page indexes must return to 0 with it -- otherwise a
  // user on page 2+ sliced past the end of the new rows and sat on "Loading…"
  // forever, and later pages were never fetched. Keeps the current search,
  // sort and filters (getCp/getFos default to the applied date/status ones).
  function mobileReloadCp() {
    setPageMaintain(0);
    setPageNumber(0);
    getCp(0, false, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal);
  }

  function mobileReloadFos() {
    setPageMaintainFos(0);
    setPageNumberFos(0);
    getFos(0, false, searchFos, selectedStatusArray, selectedTypeArray, drpDownSelectedVal);
  }

  // Patch the open detail page in place, so its status and action bar reflect
  // the change instead of offering the same action again.
  function patchMobileDetailRow(rowId, changes) {
    setMobileDetailRow((cur) => (cur && cur.id === rowId ? { ...cur, ...changes } : cur));
  }

  function mobileApprove(row) {
    // Only an approval that completes in this attempt counts.
    mobileApprovedIdsRef.current.delete(row.id);
    approvedStatus(row.id, () => {
      mobileApprovedIdsRef.current.add(row.id);
      patchMobileDetailRow(row.id, { approvalStatus: "approved" });
      setMobileReviewedCpId(null);
      mobileReloadCp();
    });
  }

  // Mirrors the desktop "Suspend FOS?" ConfirmationAlert handler, including
  // the insertFosLogs audit entry.
  function mobileConfirmFosSuspend() {
    const fosRow = fosToSuspend;
    if (!fosRow) return;
    setSuspendFosAlert(false);
    presentLoader();
    suspendFos(fosRow.id)
      .then(() => {
        dismissLoader();
        showSuccess(`${fosRow.name} was disabled successFully!`);
        insertFosLogs(fosRow.id, "suspended", null).catch((err) => {
          console.error("insertFosLogs", err);
        });
        setMobileFosDetailRow(null);
        setFosToSuspend(null);
        mobileReloadFos();
      })
      .catch((err) => {
        dismissLoader();
        console.error("suspendFos", err);
        showError(
          err?.response?.data?.message || err.message || "Could not suspend this FOS."
        );
      });
  }

  // Same filter ThreeDotsMenu applies at the CP Action column, so the mobile
  // sheet offers exactly the actions desktop offers for the same row.
  function mobileCpMenuItems(row) {
    if (row.Disabled) return ["Enable"];
    return (row.tempSideMenuArrayCP ?? []).filter((each) => {
      if (row.approvalStatus === "disable") {
        return each.value === "View Details";
      }
      if (row.approvalStatus === "approved") {
        return (
          row.approvalStatus !== each.value && (each.meta?.showInApproval ?? true)
        );
      }
      if (row.approvalStatus === "Profile Update") {
        if (each.value === "approved" || each.meta?.onlyInApproval) return false;
        return each.meta?.showInApproval ?? true;
      }
      if (row.approvalStatus === "rejected") {
        if (each.meta?.onlyInApproval) return false;
        return row.approvalStatus !== each.value;
      }
      if (row.approvalStatus === "resubmitted") {
        if (each.meta?.duplicate) return false;
        if (each.meta?.onlyInApproval) return false;
        return each.meta?.showInResubmitted ?? true;
      }
      if (each.meta?.duplicate) return false;
      if (each.meta?.onlyInApproval) return false;
      return true;
    });
  }

  // Returns the real menu item, not a synthetic one — Reject and Suspend both
  // carry value "rejected" and are only distinguishable by label, so the detail
  // action bar has to forward the actual item or Suspend would reject instead.
  function mobileMenuItem(row, value) {
    return mobileCpMenuItems(row).find((each) => each?.value === value) ?? null;
  }

  // Runs once the summary modal's checks have passed and a note has been
  // entered. Shared by the desktop grid and the mobile action sheet so both
  // record the same CpLogs entry -- the mobile path previously suspended without
  // writing any log row at all, which left its suspends with no reason on record.
  // `reload` as in approvedStatus: mobile-only, desktop keeps its refresh.
  function handleSuspendConfirmed(note, reload) {
    if (!cpToSuspend) return;
    const cp = cpToSuspend;
    setSuspendSummaryOpen(false);
    presentLoader();
    suspendCp(cp.id)
      .then(() => {
        dismissLoader();
        showSuccess(`${cp.billingName} was disabled successFully!`);
        insertCpLogs(cp.id, "suspended", loggedInUser.id, note).catch((err) => {
          console.error("insertCpLogs", err);
        });
        setMobileDetailRow(null);
        setCpToSuspend(null);
        if (reload) {
          reload();
          return;
        }
        getCp(
          0,
          false,
          search,
          selectedStatusArray,
          selectedTypeArray,
          drpDownSelectedVal
        );
      })
      .catch((err) => {
        dismissLoader();
        console.error("suspendCp", err);
        showError(err.message);
      });
  }

  function mobileActionSelect(item) {
    const row = mobileActionSheet?.row ?? mobileDetailRow ?? mobileFosDetailRow;
    if (!row) return;

    if (item.value === "rejected") {
      // Reject and Suspend share value "rejected" and are told apart by label,
      // exactly as the desktop Action cell does. Suspend opens the same two-step
      // confirm + summary flow the desktop Action cell uses, not the
      // reject-reason modal.
      if (item.label === "Suspend") {
        setCpToSuspend(row);
        setSuspendSummaryOpen(true);
      } else {
        setViewData(row);
        setRejectResponse(true);
      }
    } else if (item.value === "Suspend") {
      // FOS menus are plain strings, so Suspend arrives as its own value.
      // Same "Suspend FOS?" confirmation desktop shows before suspending.
      setFosToSuspend(row);
      setSuspendFosAlert(true);
    } else if (item.value === "approved") {
      setViewData(row);
      // Already through the info alert and on the details -- approve
      // directly, as desktop's ViewCPDetails Accept does.
      if (mobileReviewedCpId === row.id) {
        mobileApprove(row);
        setMobileActionSheet(null);
        return;
      }
      if (row.isFlagged) {
        setStatusButton(true);
        setDisplayMessage("This User is created with Different Name.View Details");
        setOpenConfirmation(true);
      } else {
        mobileApprove(row);
      }
      if (row.approvalStatus === "resubmitted") {
        setOpenConfirmation(true);
        setDisplayMessage("This User has resubmited his data");
        setStatusButton(true);
      }
    } else if (item.value === "View Details") {
      setStatusButton(false);
      setViewData(row);
      if (tabValue === "CP") {
        setMobileDetailRow(row);
      } else {
        // Full page on mobile, matching CP — not the ViewFOSIDDetails modal.
        setMobileFosDetailRow(row);
      }
    } else if (item.value === "Assign Benefit Plan") {
      setViewData(row);
      setAssignBenfitPlanModal(true);
    } else if (item.value === "View FOS Details") {
      setViewData(row);
      setViewFOSDetailsModal(true);
    } else if (item.value === "Reset Password") {
      setViewData(row);
      // FOS rows have no billingName -- desktop's FOS menu names them by name.
      const recipient = tabValue === "CP" ? row.billingName : row.name;
      sendResetPasswordMailCP(row.email)
        .then(() => {
          showSuccess(
            "Reset password link sent successfully to " +
              recipient +
              "( " +
              row.email +
              " )"
          );
        })
        .catch(() => {
          showError("Could not send reset password link to " + recipient);
        });
    } else if (item.value === "Enable" && tabValue === "CP") {
      // CP only, as on desktop: a disabled CP's menu is just "Enable", while a
      // disabled FOS's menu is just "View Details" -- desktop never offers
      // Enable for a FOS, so mobile doesn't either.
      enableCp(row, mobileReloadCp).catch((err) => {
        console.log("enable failed", err);
        showError("Could not enable " + row.billingName);
      });
    } else if (item.value === "Profile Update") {
      presentLoader();
      unlockCpProfileForEdit(row.cpId, loggedInUser.id)
        .then((res) => {
          dismissLoader();
          if (res.blocked) {
            showError(res.message);
            return;
          }
          showSuccess(`Profile editing unlocked for ${row.billingName}.`);
          patchMobileDetailRow(row.id, { approvalStatus: "Profile Update" });
          mobileReloadCp();
        })
        .catch((err) => {
          dismissLoader();
          console.error("unlockCpProfileForEdit", err);
          showError("Failed to unlock profile editing.");
        });
    }
    setMobileActionSheet(null);
  }

  if (isMobile) {
    return (
      <>
        <PartnersMobile
          // Role-filtered, same list the desktop Tabs render.
          tabs={tabs}
          cpLoaded={cp !== initialCpRef.current}
          fosLoaded={fos !== initialFosRef.current}
          tabValue={tabValue}
          tabChange={mobileTabChange}
          cp={cp}
          fos={fos}
          totalCount={totalCount}
          totalFOSCount={totalFOSCount}
          search={search}
          searchFos={searchFos}
          onSearch={mobileSearch}
          onSearchFos={mobileSearchFos}
          sortValue={drpDownSelectedVal}
          onSort={mobileSort}
          statuses={selectedStatusArray}
          types={selectedTypeArray}
          datePreset={mobileDatePreset}
          customRange={appliedDatesRef.current}
          onApplyFilters={mobileApplyFilters}
          onClearFilters={mobileClearFilters}
          onRemoveFilterTag={mobileRemoveFilterTag}
          fosStatuses={fosStatusArray}
          fosDatePreset={fosDatePreset}
          fosCustomRange={fosAppliedDatesRef.current}
          onApplyFosFilters={mobileApplyFosFilters}
          onClearFosFilters={mobileClearFosFilters}
          onRemoveFosFilterTag={mobileRemoveFosFilterTag}
          page={pageMaintain}
          pageFos={pageMaintainFos}
          onPageChange={mobilePageChange}
          onPageChangeFos={mobilePageChangeFos}
          pageSize={pageSize}
          onOpenPartner={(row) => setMobileDetailRow(row)}
          onPartnerAction={(row) =>
            setMobileActionSheet({
              row,
              title: row.cpDisplayId,
              items: mobileCpMenuItems(row),
            })
          }
          onOpenFos={(row) => {
            setViewData(row);
            setMobileFosDetailRow(row);
          }}
          onFosAction={(row) =>
            setMobileActionSheet({
              row,
              title: fosDisplayLabel(row),
              items: row.isDisabled
                ? ["View Details"]
                : row.approvalStatus === "disable"
                ? (row.fosThreeDotsMenu ?? []).filter(
                    (item) => item === "View Details"
                  )
                : row.fosThreeDotsMenu ?? [],
            })
          }
          detailRow={mobileDetailRow}
          detailDocs={mobileDetailDocs}
          onCloseDetail={() => setMobileDetailRow(null)}
          onApprove={() => {
            const item = mobileMenuItem(mobileDetailRow, "approved");
            if (item) mobileActionSelect(item);
          }}
          onReject={() => {
            const item = mobileMenuItem(mobileDetailRow, "rejected");
            if (item) mobileActionSelect(item);
          }}
          canApprove={Boolean(
            mobileDetailRow && mobileMenuItem(mobileDetailRow, "approved")
          )}
          canReject={Boolean(
            mobileDetailRow && mobileMenuItem(mobileDetailRow, "rejected")
          )}
          // "Reject" on a pending partner, "Suspend" on an approved one —
          // whichever the role-filtered menu actually offers.
          rejectLabel={
            mobileMenuItem(mobileDetailRow ?? {}, "rejected")?.label ?? "Reject"
          }
          fosDetailRow={mobileFosDetailRow}
          fosDetailDocs={mobileFosDetailDocs}
          onCloseFosDetail={() => setMobileFosDetailRow(null)}
          actionSheet={mobileActionSheet}
          onActionSelect={mobileActionSelect}
          onCloseActionSheet={() => setMobileActionSheet(null)}
        />
        {/* Phone layout of the desktop ViewFOSDetails modal -- same query and
            content. That modal never calls returnResp, so nothing to reload. */}
        <CpFosListSheet
          open={viewFOSDetailsModal}
          cp={viewData}
          onClose={() => setViewFOSDetailsModal(false)}
        />
        {rejectResponse && (
          <RejectReason
            open={rejectResponse}
            handleClose={() => setRejectResponse(false)}
            loggedInUserId={loggedInUser.id}
            // RejectReason only ever reports success (saveResp(true)).
            saveResp={(value) => {
              if (!value) return;
              setMobileDetailRow(null);
              mobileReloadCp();
            }}
            data={viewData}
            showError={showError}
            showInfo={showInfo}
          />
        )}
        {assignBenfitPlan && (
          <AssignBenefitPlanCP
            open={assignBenfitPlan}
            data={viewData}
            handleClose={() => setAssignBenfitPlanModal(false)}
            showSuccess={showSuccess}
            returnResp={(value) => {
              if (value) mobileReloadCp();
            }}
          />
        )}
        <ConfirmationAlert
          open={openConfirmation}
          close={() => {
            setOpenConfirmation(false);
          }}
          title={"Info !"}
          subTitle={displayMessage}
          confirm={(value) => {
            if (value === "confirmed") {
              // Desktop opens ViewCPDetails with its Accept button here; the
              // mobile detail page's Approve does the same once reviewed.
              setMobileReviewedCpId(viewData.id);
              // Prefer the refreshed row over the one captured when the
              // alert opened, and reflect an approval that already went
              // through (resubmitted CPs are approved before this alert).
              const latest = cp.find((r) => r.id === viewData.id) ?? viewData;
              const shown = mobileApprovedIdsRef.current.has(viewData.id)
                ? { ...latest, approvalStatus: "approved" }
                : latest;
              // An already-open details page is kept: mobileApprove patches
              // it in place on success.
              setMobileDetailRow((cur) =>
                cur && cur.id === viewData.id ? cur : shown
              );
              setOpenConfirmation(false);
            }
          }}
          returnRespButton={"View Details"}
        />
        {/* The mobile tree is an early return, so the modal rendered in the
            desktop tree below never mounts here -- it has to be repeated. */}
        <SuspendCpSummary
          open={suspendSummaryOpen}
          cp={cpToSuspend}
          handleClose={() => {
            setSuspendSummaryOpen(false);
            setCpToSuspend(null);
          }}
          onConfirm={(note) => handleSuspendConfirmed(note, mobileReloadCp)}
        />
        <ConfirmationAlert
          open={suspendFosAlert}
          close={() => {
            setSuspendFosAlert(false);
            setFosToSuspend(null);
          }}
          title={"Suspend FOS?"}
          subTitle={`Are you sure you want to suspend ${fosToSuspend?.name || "this FOS"}?`}
          confirm={(value) => {
            if (value === "confirmed") mobileConfirmFosSuspend();
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Suspend"}
        />
        {viewFOSIDDetailsModal && (
          <ViewFOSIDDetails
            open={viewFOSIDDetailsModal}
            data={viewData}
            handleClose={() => setViewFOSIDDetailsModal(false)}
            showError={showError}
          />
        )}
        {AlertModal}
      </>
    );
  }

  return (
    <div className="pageWrapper">
      <div className={cssClasses.wrapperHeader}>
        <div>
          <div className={cssClasses.headerTitle}>Partners</div>
          <div className={cssClasses.headerSubTitle}>
            Manage your Partners and preferences here.
          </div>
        </div>
      </div>

      <div>
        <Tabs
          value={tabValue}
          onChange={tabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={[
            {
              borderBottom: "1px solid #EAECF0 !important",
            },
          ]}
        >
          {tabList}
        </Tabs>
      </div>

      {tabValue === "CP" && (
        <div className={cssClasses.wrapperFilters}>
          <span className={cssClasses.countTitle}>{totalCount} Partners</span>
          <div className={cssClasses.containerFilterSortBy}>
            <div className={cssClasses.wrapperFilter}>
              <div className={cssClasses.filterTitle}>Filter by</div>
              <div className={cssClasses.wrapperDropDown}>
                <div
                  className={cssClasses.wrapperCustomiseDropDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowDropDown(!showDropDown);
                  }}
                >
                  <div className={cssClasses.dropDownLabel}>
                    <span className={cssClasses.dropDownLabelValue}>
                      {selectedListDropDown.join()}
                    </span>
                    {selectedListDropDown.length === 0 && (
                      <span className={cssClasses.dropDownLabelValue}>
                        None
                      </span>
                    )}
                  </div>
                  <span>
                    {" "}
                    <KeyboardArrowDownIcon
                      className={cssClasses.dropDownIcon}
                    />
                  </span>
                </div>
                {showDropDown && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setShowDropDown(false);
                    }}
                  >
                    <div className={cssClasses.containerCustomiseDropDown}>
                      <div className={cssClasses.wrapperSelectAndCheckbox}>
                        <div className={cssClasses.wrapperEachSelect}>
                          {listOfDropDown.map((each, index) => {
                            return (
                              <div
                                className={
                                  each.select
                                    ? cssClasses.selectedVal
                                    : cssClasses.containerEachSelect
                                }
                              >
                                <div
                                  className={cssClasses.eachSelect}
                                  onClick={() => {
                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      // pre[index].select = true;
                                      return [...pre];
                                    });
                                    allStatusDropDown.forEach((el) => {
                                      if (el.value) {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = true;
                                          return [...pre];
                                        });
                                      }
                                    });
                                    allTypeDropDown.forEach((el) => {
                                      if (el.value) {
                                        setListOfDropDown((pre) => {
                                          pre[2].select = true;
                                          return [...pre];
                                        });
                                      }
                                    });
                                    if (selectDates[0].value || selectDates[1].value) {
                                      setListOfDropDown((pre) => {
                                        pre[3].select = true;
                                        return [...pre];
                                      });
                                    }
                                    if (each.label === "None") {
                                      setListOfDropDown((pre) => {
                                        pre = pre.map((m) => ({
                                          ...m,
                                          select: false,
                                        }));
                                        pre[0].select = true;
                                        return [...pre];
                                      });
                                      setAllStatusDropDown((pre) => {
                                        pre = pre.map((m) => ({
                                          ...m,
                                          value: false,
                                        }));
                                        return [...pre];
                                      });
                                      setAllTypeDropDown((pre) => {
                                        pre = pre.map((m) => ({
                                          ...m,
                                          value: false,
                                        }));
                                        return [...pre];
                                      });
                                      setSelectedStatusArray([]);
                                      setSelectedTypeArray([]);
                                      setSelectDates([
                                        { label: "StartDate", value: "" },
                                        { label: "EndDate", value: "" },
                                      ]);
                                      setDateHelperText({ startDate: "", endDate: "" });
                                      setShowAllStatusDropDown(false);
                                      setShowTypeDropDown(false);
                                      setShowDateDropDown(false);
                                    } else if (each.label === "Status") {
                                      setShowAllStatusDropDown(true);
                                      setShowTypeDropDown(false);
                                      setShowDateDropDown(false);
                                    } else if (each.label === "Type") {
                                      setShowAllStatusDropDown(false);
                                      setShowTypeDropDown(true);
                                      setShowDateDropDown(false);
                                    } else if (each.label === "Date") {
                                      setShowAllStatusDropDown(false);
                                      setShowTypeDropDown(false);
                                      setShowDateDropDown(true);
                                    }
                                  }}
                                >
                                  {each.label}
                                </div>
                                {each.select && (
                                  <img
                                    src={checked}
                                    alt={"checked"}
                                    style={{ marginRight: "2rem" }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div className={cssClasses.wrapperCheckbox}>
                          {showAllStatusDropDown &&
                            allStatusDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        "& .MuiTypography-root": {
                                          fontFamily: "Inter-Medium !important",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "1.6rem !important",
                                          lineHeight: "2.4rem !important",
                                          color: "#101828",
                                          textTransform: "capitalize",
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      console.log(e.target.checked);
                                      if (e.target.checked) {
                                        setAllStatusDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedStatusArray.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllStatusDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedStatusArray(
                                          selectedStatusArray.filter(
                                            (status) => status !== each.label
                                          )
                                        );
                                      }
                                      let checkStatusSelected =
                                        allStatusDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      if (checkStatusSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === "Status"
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push("Status");
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown([
                                          ...selectedListDropDown.filter(
                                            (value) => value !== "Status"
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })}
                          {showTypeDropDown &&
                            allTypeDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        "& .MuiTypography-root": {
                                          fontFamily: "Inter-Medium !important",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "1.6rem !important",
                                          lineHeight: "2.4rem !important",
                                          color: "#101828",
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setAllTypeDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedTypeArray.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllTypeDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedTypeArray(
                                          selectedTypeArray.filter(
                                            (status) => status !== each.label
                                          )
                                        );
                                      }
                                      let checkTypeSelected =
                                        allTypeDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      if (checkTypeSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[2].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === "Type"
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push("Type");
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[2].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown([
                                          ...selectedListDropDown.filter(
                                            (value) => value !== "Status"
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })}
                          {showDateDropDown && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>Start Date</div>
                                <DateComponent
                                  value={selectDates[0].value}
                                  minDate={DATE_FILTER_MIN}
                                  dateOnly
                                  onChangeDate={(value) => {
                                    setSelectDates((pre) => {
                                      pre[0].value = value ? new Date(value).getTime() : "";
                                      return [...pre];
                                    });
                                    setDateHelperText((pre) => ({ ...pre, startDate: "", endDate: "" }));
                                    setListOfDropDown((pre) => {
                                      pre[3].select = !!value;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown((pre) =>
                                      value
                                        ? pre.includes("Date")
                                          ? pre
                                          : [...pre, "Date"]
                                        : pre.filter((v) => v !== "Date")
                                    );
                                  }}
                                  helperText={dateHelperText.startDate}
                                />
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={selectDates[1].value}
                                  minDate={DATE_FILTER_MIN}
                                  dateOnly
                                  onChangeDate={(value) => {
                                    if (!value) {
                                      setSelectDates((pre) => {
                                        pre[1].value = "";
                                        return [...pre];
                                      });
                                      setDateHelperText((pre) => ({ ...pre, endDate: "" }));
                                      return;
                                    }
                                    if (selectDates[0].value === "") {
                                      setDateHelperText((pre) => ({
                                        ...pre,
                                        endDate: "Please select start date first",
                                      }));
                                      return;
                                    }
                                    if (endOfDayMs(value) < startOfDayMs(selectDates[0].value)) {
                                      setDateHelperText((pre) => ({
                                        ...pre,
                                        endDate: "Select End Date Greater than start Date",
                                      }));
                                      return;
                                    }
                                    setSelectDates((pre) => {
                                      pre[1].value = new Date(value).getTime();
                                      return [...pre];
                                    });
                                    setDateHelperText((pre) => ({ ...pre, endDate: "" }));
                                    setListOfDropDown((pre) => {
                                      pre[3].select = true;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown((pre) =>
                                      pre.includes("Date") ? pre : [...pre, "Date"]
                                    );
                                  }}
                                  helperText={dateHelperText.endDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={cssClasses.wrapperDropDownButtons}>
                        <div>
                          <Button
                            style={{
                              color: "#344054",
                              backgroundColor: "#ffffff",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Clear"}
                            clicked={() => {
                              setListOfDropDown((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  select: false,
                                }));
                                pre[0].select = true;
                                return [...pre];
                              });
                              setAllStatusDropDown((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  value: false,
                                }));
                                return [...pre];
                              });
                              setAllTypeDropDown((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  value: false,
                                }));
                                return [...pre];
                              });
                              setShowAllStatusDropDown(false);
                              setShowTypeDropDown(false);
                              setShowDateDropDown(false);
                              setSelectedStatusArray([]);
                              setSelectedTypeArray([]);
                              setSelectDates([
                                { label: "StartDate", value: "" },
                                { label: "EndDate", value: "" },
                              ]);
                              setDateHelperText({ startDate: "", endDate: "" });
                              appliedDatesRef.current = { start: null, end: null };
                              setSelectedListDropDown([]);
                              setPageNumber(0);
                              setCP([]);
                              getCp(
                                0,
                                false,
                                search,
                                [],
                                [],
                                drpDownSelectedVal,
                                { start: null, end: null }
                              );
                            }}
                          />
                        </div>
                        <div>
                          <Button
                            style={{
                              color: "#ffffff",
                              backgroundColor: "#1570EF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Apply"}
                            clicked={() => {
                              // A start date with no end is incomplete — same
                              // guard Leads applies before it fetches.
                              if (selectDates[0].value && !selectDates[1].value) {
                                setDateHelperText((pre) => ({
                                  ...pre,
                                  endDate: "Please Select end Date",
                                }));
                                setShowAllStatusDropDown(false);
                                setShowTypeDropDown(false);
                                setShowDateDropDown(true);
                                return;
                              }

                              const range = {
                                start: selectDates[0].value
                                  ? startOfDayMs(selectDates[0].value)
                                  : null,
                                end: selectDates[1].value
                                  ? endOfDayMs(selectDates[1].value)
                                  : null,
                              };
                              appliedDatesRef.current = range;

                              setDateHelperText({ startDate: "", endDate: "" });
                              setShowDropDown(false);
                              setPageNumber(0);
                              setCP([]);
                              getCp(
                                0,
                                false,
                                search,
                                selectedStatusArray,
                                selectedTypeArray,
                                drpDownSelectedVal,
                                range
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </div>
            <div className={cssClasses.wrapperSortDropDown}>
              <div className={cssClasses.filterTitle}>Sort by</div>
              <div>
                <DropDown
                  list={[
                    "Name Ascending",
                    "Name Descending",
                    "Latest First",
                    "Oldest First",
                  ]}
                  selectedValue={drpDownSelectedVal}
                  onChangeSelect={(_value) => {
                    setPageNumber(0);
                    setCP([]);
                    setDrpDownSelectedVal(_value);
                    getCp(
                      0,
                      false,
                      search,
                      selectedStatusArray,
                      selectedTypeArray,
                      _value
                    );
                  }}
                  placeHolder={"Select"}
                  //style.color is placeHolder's color
                  style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                  helperText={""}
                />
              </div>
            </div>
          </div>
          <div className={cssClasses.wrapperSearchBar}>
            <SearchBar
              id={"CPSearch"}
              value={search}
              placeholder={"Search"}
              search={debouncedFetchSearchData}
              width="100%"
            />
          </div>
        </div>
      )}
      {tabValue === "FOS" && (
        <div className={cssClasses.wrapperFilters}>
          <span className={cssClasses.countTitle}>{totalFOSCount} Fos</span>
          <div className={cssClasses.containerFilterSortBy}>
            {/* Status + Date only — FOS has no partner type. Built separately
                from the CP dropdown so CP's filter behaviour is untouched. */}
            <div className={cssClasses.wrapperFilter}>
              <div className={cssClasses.filterTitle}>Filter by</div>
              <div className={cssClasses.wrapperDropDown}>
                <div
                  className={cssClasses.wrapperCustomiseDropDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFosDropDown(!showFosDropDown);
                  }}
                >
                  <div className={cssClasses.dropDownLabel}>
                    <span className={cssClasses.dropDownLabelValue}>
                      {fosSelectedListDropDown.length === 0
                        ? "None"
                        : fosSelectedListDropDown.join()}
                    </span>
                  </div>
                  <span>
                    <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                  </span>
                </div>
                {showFosDropDown && (
                  <ClickAwayListener
                    onClickAway={() => setShowFosDropDown(false)}
                  >
                    <div className={cssClasses.containerCustomiseDropDown}>
                      <div className={cssClasses.wrapperSelectAndCheckbox}>
                        <div className={cssClasses.wrapperEachSelect}>
                          {["None", "Status", "Date"].map((dimension) => (
                            <div
                              key={dimension}
                              className={
                                fosFilterDimension === dimension
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  if (dimension === "None") {
                                    clearFosDesktopFilters();
                                    setShowFosDropDown(true);
                                    return;
                                  }
                                  setFosFilterDimension(dimension);
                                }}
                              >
                                {dimension}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className={cssClasses.wrapperCheckbox}>
                          {fosFilterDimension === "Status" &&
                            fosStatusOptions.map((each, index) => (
                              <FormGroup key={each.label}>
                                <FormControlLabel
                                  checked={each.value}
                                  onChange={(e) => {
                                    setFosStatusOptions((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    const anySelected =
                                      fosStatusOptions.filter(
                                        (o, i) =>
                                          i === index
                                            ? e.target.checked
                                            : o.value
                                      ).length > 0;
                                    setFosSelectedListDropDown((pre) =>
                                      anySelected
                                        ? pre.includes("Status")
                                          ? pre
                                          : [...pre, "Status"]
                                        : pre.filter((v) => v !== "Status")
                                    );
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": { fontSize: 28 },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            ))}

                          {fosFilterDimension === "Date" && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>
                                  Start Date
                                </div>
                                <DateComponent
                                  value={fosSelectDates[0].value}
                                  minDate={DATE_FILTER_MIN}
                                  dateOnly
                                  onChangeDate={(value) => {
                                    setFosSelectDates((pre) => {
                                      pre[0].value = value
                                        ? new Date(value).getTime()
                                        : "";
                                      return [...pre];
                                    });
                                    setFosDateHelperText({
                                      startDate: "",
                                      endDate: "",
                                    });
                                    setFosSelectedListDropDown((pre) =>
                                      value
                                        ? pre.includes("Date")
                                          ? pre
                                          : [...pre, "Date"]
                                        : pre.filter((v) => v !== "Date")
                                    );
                                  }}
                                  helperText={fosDateHelperText.startDate}
                                />
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={fosSelectDates[1].value}
                                  minDate={DATE_FILTER_MIN}
                                  dateOnly
                                  onChangeDate={(value) => {
                                    if (!value) {
                                      setFosSelectDates((pre) => {
                                        pre[1].value = "";
                                        return [...pre];
                                      });
                                      setFosDateHelperText((pre) => ({
                                        ...pre,
                                        endDate: "",
                                      }));
                                      return;
                                    }
                                    if (fosSelectDates[0].value === "") {
                                      setFosDateHelperText((pre) => ({
                                        ...pre,
                                        startDate: "Please Select start Date",
                                      }));
                                      return;
                                    }
                                    if (
                                      endOfDayMs(value) <
                                      startOfDayMs(fosSelectDates[0].value)
                                    ) {
                                      setFosDateHelperText((pre) => ({
                                        ...pre,
                                        endDate:
                                          "End date cannot be before start date",
                                      }));
                                      return;
                                    }
                                    setFosSelectDates((pre) => {
                                      pre[1].value = new Date(value).getTime();
                                      return [...pre];
                                    });
                                    setFosDateHelperText({
                                      startDate: "",
                                      endDate: "",
                                    });
                                  }}
                                  helperText={fosDateHelperText.endDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={cssClasses.wrapperDropDownButtons}>
                        <div>
                          <Button
                            style={{
                              color: "#344054",
                              backgroundColor: "#ffffff",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Clear"}
                            clicked={clearFosDesktopFilters}
                          />
                        </div>
                        <div>
                          <Button
                            style={{
                              color: "#ffffff",
                              backgroundColor: "#1570EF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Apply"}
                            clicked={applyFosDesktopFilters}
                          />
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </div>

            <div className={cssClasses.wrapperSortDropDown}>
              <div className={cssClasses.filterTitle}>Sort by</div>
              <div>
                <DropDown
                  list={[
                    "Name Ascending",
                    "Name Descending",
                    "Latest First",
                    "Oldest First",
                  ]}
                  selectedValue={drpDownSelectedVal}
                  onChangeSelect={(_value) => {
                    setPageNumberFos(0);
                    setFos([]);
                    setDrpDownSelectedVal(_value);
                    getFos(
                      0,
                      false,
                      searchFos,
                      selectedStatusArray,
                      selectedTypeArray,
                      _value
                    );
                  }}
                  placeHolder={"Select"}
                  //style.color is placeHolder's color
                  style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                  helperText={""}
                />
              </div>
            </div>
          </div>
          <div className={cssClasses.wrapperSearchBar}>
            <SearchBar
              id={"FosSearch"}
              value={searchFos}
              placeholder={"Search"}
              search={debouncedFetchSearchDataFos}
              width="100%"
            />
          </div>
        </div>
      )}
      {tabValue === "CP" && (
        <div className={cssClasses.wrapperTable}>
          <DataGrid
            rows={cp}
            columns={columns}
            pageSize={10}
            page={pageMaintain}
            rowsPerPageOptions={[10]}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
                // setPageNumber(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </div>
      )}
      {tabValue === "FOS" && (
        <div className={cssClasses.wrapperTable}>
          <DataGrid
            rows={fos}
            columns={fosColumn}
            pageSize={10}
            page={pageMaintainFos}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintainFos(_page);
              if (pageNumberFos < _page) {
                // getMoreDataFos(_page);
                getMoreFosData(_page);
                setPageNumberFos(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </div>
      )}
      {viewCPDetailsModal && (
        <ViewCPDetails
          open={viewCPDetailsModal}
          data={viewData}
          handleClose={() => {
            setViewCPDetailsModal(false);
          }}
          showStatusButton={statusButton}
          showError={showError}
          showInfo={showInfo}
          returnResp={(value) => {
            if (value) {
              getCp(
                0,
                false,
                search,
                selectedStatusArray,
                selectedTypeArray,
                drpDownSelectedVal
              );
            }
          }}
        />
      )}
      {viewFOSDetailsModal && (
        <ViewFOSDetails
          open={viewFOSDetailsModal}
          data={viewData}
          handleClose={() => {
            setViewFOSDetailsModal(false);
          }}
          returnResp={(value) => {
            if (value) {
              getCp(
                0,
                false,
                search,
                selectedStatusArray,
                selectedTypeArray,
                drpDownSelectedVal
              );
            }
          }}
        />
      )}
      {rejectResponse && (
        <RejectReason
          open={rejectResponse}
          handleClose={() => {
            setRejectResponse(false);
          }}
          loggedInUserId={loggedInUser.id}
          saveResp={cpRejected}
          data={viewData}
          showError={showError}
          showInfo={showInfo}
        />
      )}
      {assignBenfitPlan && (
        <AssignBenefitPlanCP
          open={assignBenfitPlan}
          data={viewData}
          handleClose={() => {
            setAssignBenfitPlanModal(false);
          }}
          showSuccess={showSuccess}
          returnResp={(value) => {
            if (value) {
              getCp(
                0,
                false,
                search,
                selectedStatusArray,
                selectedTypeArray,
                drpDownSelectedVal
              );
            }
          }}
        />
      )}
      <ConfirmationAlert
        open={openConfirmation}
        close={() => {
          setOpenConfirmation(false);
        }}
        // icon={<GreenChecked width={"4.8rem"} height={"4.8rem"} />}
        title={"Info !"}
        subTitle={displayMessage}
        confirm={(value) => {
          if (value === "confirmed") {
            setViewCPDetailsModal(true);
            setOpenConfirmation(false);
          }
          //  else if(value==='rejected'){
          //   approvedStatus(viewData.id);
          //   setOpenConfirmation(false);
          //  }
          console.log(value);
        }}
        // buttonTitle={"Accept"}
        returnRespButton={"View Details"}
      />
      <SuspendCpSummary
        open={suspendSummaryOpen}
        cp={cpToSuspend}
        handleClose={() => {
          setSuspendSummaryOpen(false);
          setCpToSuspend(null);
        }}
        onConfirm={handleSuspendConfirmed}
      />
      <ConfirmationAlert
        open={suspendFosAlert}
        close={() => {
          setSuspendFosAlert(false);
        }}
        title={"Suspend FOS?"}
        subTitle={`Are you sure you want to suspend ${fosToSuspend?.name || "this FOS"}?`}
        confirm={(value) => {
          if (value === "confirmed") {
            setSuspendFosAlert(false);
            presentLoader();
            suspendFos(fosToSuspend.id)
              .then(() => {
                dismissLoader();
                showSuccess(`${fosToSuspend.name} was disabled successFully!`);
                insertFosLogs(fosToSuspend.id, "suspended", null).catch((err) => {
                  console.error("insertFosLogs", err);
                });
                getFos(
                  0,
                  false,
                  "",
                  selectedStatusArray,
                  selectedTypeArray,
                  "Latest First"
                );
              })
              .catch((err) => {
                dismissLoader();
                console.error("suspendFos", err);
                showError(err?.response?.data?.message || err.message || "Could not suspend this FOS.");
              });
          }
        }}
        buttonTitle={"Cancel"}
        returnRespButton={"Suspend"}
      />
      {viewFOSIDDetailsModal && (
        <ViewFOSIDDetails
          open={viewFOSIDDetailsModal}
          data={viewData}
          handleClose={() => {
            setViewFOSIDDetailsModal(false);
          }}
          showError={showError}
        />
      )}
      {AlertModal}
    </div>
  );
}
